module.exports = __webpack_public_path__ + "images/b2b-img3.jpg";